import React from 'react'

const Home = () => {
  return (
    <div className="container">
      
      <h3>Welcome to Image Browser.
      Search for high quality images as per your requirement. </h3>
</div>
  )
}

export default Home